module.exports = __webpack_public_path__ + "img/@logo_hnq@3x.5f5a4bef.png";